import { render } from "./Header.component.vue?vue&type=template&id=53cefe87&ts=true"
import script from "./Header.component.vue?vue&type=script&lang=ts"
export * from "./Header.component.vue?vue&type=script&lang=ts"

import "./Header.component.vue?vue&type=style&index=0&id=53cefe87&lang=css"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__